import React from 'react';
import Skeleton from 'react-loading-skeleton';

const SkeletonDialogGoogleClassroomImportUsers = ({ rows }) => {
  return <Skeleton className="classroom-list__item-skeleton" count={rows} />;
};

SkeletonDialogGoogleClassroomImportUsers.defaultProps = {
  rows: 3,
};

export default SkeletonDialogGoogleClassroomImportUsers;
